import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Configure, InstantSearch } from 'react-instantsearch/dom';
import { connectHits } from 'react-instantsearch-dom';
import { getImgixUrl, getUrlHandle } from 'ck-utils';
import { Typography, LazyLoadImage } from 'ck-ui';
import { trackAlgoliaClick } from 'ck-utils/algoliaAnalytics';
import { algoliaClient, INDEX_PRODUCTS, userToken } from 'src/lib/algolia';
import styles from './ColorWays.module.scss';

const Hits = ({ hits }) => {
  if (!hits || hits.length < 1) {
    return null;
  }
  // we still need to display colorway even if only one is returned, as long as it is not the current product
  if (hits.length === 1 && getUrlHandle() === hits[0].handle) {
    return null;
  }
  return (
    <div className={styles.root}>
      <Typography display="block" color="black-bis" className={styles.heading}>
        Available In:
      </Typography>
      <div className={styles.itemsContainer}>
        {hits.map(hit => (
          <a
            title={hit.colourString}
            href={hit.handle}
            key={hit.productId}
            className={classnames({
              [styles.item]: true,
              [styles.selected]: getUrlHandle() === hit.handle
            })}
            onClick={() => trackAlgoliaClick({
              index: `${INDEX_PRODUCTS}_colorway`,
              eventName: 'product_click',
              queryID: hit.__queryID,
              objectID: hit.objectID,
              position: hit.__position
            })}
          >
            <LazyLoadImage
              src={getImgixUrl(hit.image, ['fit=crop', 'h=150', 'w=120'])}
              width="120"
              height="150"
              alt={hit.title}
            />
          </a>
        ))}
      </div>
    </div>
  );
};

Hits.propTypes = {
  hits: PropTypes.array.isRequired
};

const ColorwayHits = connectHits(Hits);

const Colorways = ({ productStyleGroup = '' }) => {
  if (!productStyleGroup) return null;
  return (
    <InstantSearch
      searchClient={algoliaClient}
      indexName={`${INDEX_PRODUCTS}_colorway`}
    >
      <Configure
        facetFilters={[
          'inStock:true',
          'isOnline:true',
          `styleGroup:${productStyleGroup}`,
        ]}
        clickAnalytics
        userToken={userToken}
        analyticsTags={['web', 'colorway']}
      />
      <ColorwayHits />
    </InstantSearch>
  );
};

Colorways.propTypes = {
  productStyleGroup: PropTypes.string
};

export { Colorways };
